module.exports = __webpack_public_path__ + "img/carousel-1-slide-3.b74101dc.webp";